module.exports = __webpack_public_path__ + "img/searchRocket.de069ef7.png";